import React from 'react';
import { Card, Col, Row } from 'antd';
import moment from 'moment';
import display from 'constants/display';
import DisplayAmount from './DisplayAmount';

const CardConciliation = ({ transaction }) => {
  return (
    <Card
      className="gx-cardconciliation"
      title={display[transaction.status]}
      typeof={transaction.status}
    >
      <Row
        className="gx-mb-4 no-padding no-margin"
        align="middle"
        justify="space-between"
      >
        <Col>
          <div>{moment(transaction.date).format('DD/MM/YYYY')}</div>
          <div>{moment(transaction.date).format('dddd')}</div>
        </Col>
        <Col>
          <DisplayAmount amount={transaction.amount} />
        </Col>
      </Row>

      <Row className="gx-mb-4 no-padding no-margin">
        <Col>
          <span className="gx-font-weight-semi-bold gx-text-uppercase">
            {transaction.description}
          </span>
        </Col>
      </Row>

      <Row className="no-padding no-margin">
        <Col>
          <span className="gx-fs-sm">{`Arquivo OFX: ${transaction.openFinancialExchangeCode}`}</span>
        </Col>
      </Row>
    </Card>
  );
};

export default CardConciliation;
